import { ChangeDetectorRef, Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, HostListener, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AspMyBookingsService } from './asp-my-bookings.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { fuseAnimations } from '@fuse/animations';
import { SideBarJobcardComponent } from '../side-bar-jobcard/side-bar-jobcard.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
// import { AspRecordPaymentComponent } from '../asp-record-payment/asp-record-payment.component';
import { NgForm } from '@angular/forms';
import { AspLoadingService } from '../asp-loading/asp-loading.service';

interface Booking {
  createdAt: string | number | Date;
  bookingId: string;
  issue: string;
  phoneNumber: string;
  registratioNumber: string;
  name: string;      // ✅ add this
  tagDeal: string[]; 
  tag:String[];
  couponCode:String[];
}

@Component({
  selector: 'app-asp-my-bookings',
  templateUrl: './asp-my-bookings.component.html',
  styleUrls: ['./asp-my-bookings.component.scss'],
  animations: fuseAnimations
})
export class AspMyBookingsComponent implements OnInit
 {
  loading: boolean = false;
  requestList: Booking[] = [];
  formSubmitted: boolean = false;
  isSidebarOpen: boolean = false;
  customerName: string = '';
  customerMobile: string = '';
  isPopupOpen: boolean = false;
  successIcon: string = '../../../../assets/icons/icons8-ok.gif';
  data: Booking | null = null;
  currentText: string = '';
  searchOptions = ["Search By 'Booking ID'", "Search By 'Name'", "Search By 'Mobile Number'"];
  currentIndex: number = 0;
  textInterval: any;
  searchText: string = ''; // Search text property
  bookingId: string;
  issue: string;
  orderID: void;
  createdAt: string;
  isJobCardSidebarOpen = false;
  isConfirmationSidebarOpen = false;
  submitted = false;
  filteredRequestList: Booking[] = []; // Filtered list
  allRequests: Booking[] = []; // This holds all bookings
  emptyList: any = 'assets/images/no-cart.png';
  // New properties for vehicle registration form
  vehicleForm1: FormGroup;
  vehicleInfo: boolean = false;
  vehicleData: any;
  sidebarOpen: boolean;
  isMobile: boolean;
  showRecordPayment = false;
  isKeyboardOpen = false;
  tag: any;
  isBookingFormValid = false;
  isInputVisible = false;
  selectedRequestTime: string | null = null;
  selectedRequestTimeLabel: string | null = null;
  registratioNumber: string;
  isFilterSidebarOpen: boolean;
  bookingList: any[] = [];
  requestTimeOptions = [
    { label: 'Today', value: 'TODAY' },
    { label: 'Yesterday', value: 'YESTERDAY' },
    { label: 'Last 7 days', value: 'LAST_7_DAYS' },
    { label: 'Last 30 days', value: 'LAST_30_DAYS' },
    { label: 'This month', value: 'THIS_MONTH' },
    { label: 'Last month', value: 'LAST_MONTH' },
    { label: 'Any time', value: 'ANY_TIME' }
  ];
  tempRequestTime: string | null = null;
  registrationNumber: string;

  constructor(
    private aspMyBookingsService: AspMyBookingsService,
    private _formBuilder: FormBuilder,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private resolver: ComponentFactoryResolver,
    private breakpointObserver: BreakpointObserver,
    private aspLoadingService: AspLoadingService,
  ) {
      this.breakpointObserver.observe([Breakpoints.Handset])
    .subscribe(result => {
      this.isMobile = result.matches;
    }); }

  ngOnInit(): void {
    this.fetchBookings();
    this.scrollText();

    // Initialize vehicleForm1 instead of vehicleForm
    this.vehicleForm1 = this._formBuilder.group({
      regNo: ['', [Validators.required,Validators.maxLength(13)]]
    });

    this.vehicleForm1.get('regNo')?.valueChanges.subscribe(value => {
      if (value) {
        const formattedValue = this.formatRegNo(value);
        this.vehicleForm1.get('regNo')?.setValue(formattedValue, { emitEvent: false });
      }
    });

    // Check for existing vehicle data in local storage
    this.vehicleData = JSON.parse(localStorage.getItem('vehicleData'));
    this.vehicleInfo = !!this.vehicleData; // Set to true if vehicleData exists
  }

  get f() {
    return this.vehicleForm1.controls;
  }
  @HostListener('window:resize', [])
  onResize() {
    this.checkIfKeyboardIsOpen();
  }

  scrollText() {
    this.textInterval = setInterval(() => {
      this.currentText = this.searchOptions[this.currentIndex];
      this.currentIndex = (this.currentIndex + 1) % this.searchOptions.length;
    }, 2000); // Change scroll interval as needed
  }

  onInputChange(): void {
    if (!this.searchText || this.searchText.trim().length === 0) {
      this.requestList = [...this.allRequests];
      this.scrollText();
      return;
    }

    clearInterval(this.textInterval);
    this.filterRequests();
  }

  filterRequests(): void {
    const searchValue = this.searchText.trim().toLowerCase();

    this.requestList = this.allRequests.filter((request: any) => {
      const bookingId = String(request.bookingId ?? '').toLowerCase();
      const name = String(request.name ?? '').toLowerCase();
      const issue = String(request.issue ?? '').toLowerCase();
      const phone = String(request.phoneNumber ?? '');
      const regNo = String(request.registratioNumber ?? '').toLowerCase();

      return (
        bookingId.includes(searchValue) ||
        name.includes(searchValue) ||
        issue.includes(searchValue) ||
        phone.includes(searchValue) ||
        regNo.includes(searchValue)
      );
    });
  }

  clearSearch(): void {
    this.searchText = '';
    this.isInputVisible = false; 
    this.fetchBookings();
    this.scrollText();
    this.requestList = this.requestList || [];
  }

  toggleSidebar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  fetchBookings(): void {
  this.aspLoadingService.show();
  const garageKey = localStorage.getItem('garageKey');

  this.aspMyBookingsService.getMyBookings(garageKey).subscribe(
    (result: any) => {
      this.aspLoadingService.hide();
      if (result && result.code === 200) {
        this.requestList = result.data.bookings.map((booking: any) => ({
          ...booking,
          tag: this.decodeHtmlEntities(booking.tag),
          tagDeal: this.decodeHtmlEntities(booking.tagDeal)
        }));

        this.allRequests = [...this.requestList];

        this.requestList.sort(
          (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );

        // console.log("Decoded requestList:", this.requestList);
      }
    },
    (error: HttpErrorResponse) => {
      this.aspLoadingService.hide();
      console.error('Error fetching bookings:', error);
    }
  );
}

// Helper to decode HTML entities
decodeHtmlEntities(html: string): string {
  if (!html) return '';
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

  onSubmit(form: NgForm): void {
    this.formSubmitted = true;
    
    if (form.valid) {
      this.aspLoadingService.show();
      const garageKey = localStorage.getItem("garageKey");
      const userKey = localStorage.getItem('spareUserKey');
      console.log("this.issues=========================", this.issue,)
      this.aspMyBookingsService.createBooking(garageKey, userKey, this.customerName, this.customerMobile,  this.issue, this.registratioNumber ).subscribe(
        (res: any) => {
          if (res && res.code === 200) {
            this.aspLoadingService.hide();
            const newBooking: Booking = {
              bookingId: res.data.bookingId,
              name: this.customerName,
              phoneNumber: this.customerMobile,
              registratioNumber: this.registratioNumber,
              issue: this.issue,
              createdAt: res.data.createdAt,
              tagDeal:res.data.tagDeal,
              tag:res.data.tag,
              couponCode: res.data.couponCode
            };
  
            this.addNewBookingToList(newBooking);
            this.orderID = res.data;
            this.openPopup(res.data.bookingId, res.data.createdAt);
            this.toggleSidebar();
            this.formSubmitted = false;
          } else {
            this.aspLoadingService.hide();
            this.toastr.error('Error creating booking');
          }
        },
        (error: HttpErrorResponse) => {
          this.aspLoadingService.hide();
          this.toastr.error('Error creating booking');
        }
      );
    } else {
      form.controls['customerName'].markAsTouched();
      form.controls['customerMobile'].markAsTouched();
      form.controls['registratioNumber']?.markAsTouched();
      form.controls['issue']?.markAsTouched();
    }
  }

  addNewBookingToList(newBooking: Booking): void {
    this.requestList.unshift(newBooking);
  }

  openPopup(bookingId: string, createdAt: string): void {
    this.bookingId = bookingId;
    this.createdAt = createdAt;
    this.isPopupOpen = true;
  }

  closePopup(): void {
    this.isPopupOpen = false;
  }
  private formatName(name: string): string {
    if (!name) return 'NA';
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }
  shareOnWhatsApp(data: any): void {
  if (!data) {
    alert('No booking data available to share.');
    return;
  }

  const garageName =
    localStorage.getItem('spareSelectedGarageName') || 'Autoverse Garage';

  const message = 
`📄 *Booking Created*

Hello ${this.formatName(data.name)} 👋,

Your vehicle booking has been successfully created at *${garageName}*.

🛠️ Our team will call you shortly to discuss the details and next steps.

*Booking Details:*

🆔 *Booking ID:* ${data.bookingId}
🚗 *Car Registration:* ${(data.registratioNumber || 'NA').toUpperCase()}
📅 *Booking Date:* ${this.formatDate(data.createdAt)}
⚠️ *Issues Shared:* ${data.issue || 'NA'}

Thank you for choosing *${garageName}* 🙏

We’ll be in touch shortly to assist you further 😊.
`;

  const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
  window.open(url, '_blank');
}


  toggleJobCardSidebar(bookingId: string = '', name: string = '', phoneNumber: string = '',registratioNumber: string = '',issue: string = ''): void {
    this.isJobCardSidebarOpen = !this.isJobCardSidebarOpen;

    if (this.isJobCardSidebarOpen) {
      this.bookingId = bookingId;
      this.customerName = name;
      this.customerMobile = phoneNumber;
      this.registratioNumber = registratioNumber;
      this.issue = issue;
    }
  }

  toggleConfirmationSidebar(): void {
    this.isConfirmationSidebarOpen = !this.isConfirmationSidebarOpen;

    // Close other sidebars if the confirmation sidebar is opened
    if (this.isConfirmationSidebarOpen) {
      this.isSidebarOpen = false;
      this.isJobCardSidebarOpen = false;
    }
  }

  confirmCarDetails(): void {
    this.toggleConfirmationSidebar();
    this.isPopupOpen = true;
  }

  onRegDecodeSubmit(): void {
    this.loading = true;

    this.aspMyBookingsService.regDecode(this.f.regNo.value.replace(/\s/g, '')).subscribe(res => {
      // handle the response
    });
  }

  onSearch(): void {
    const searchLower = this.searchText.trim().toLowerCase();
  
    if (!searchLower) {
      this.requestList = [...this.allRequests];
      return;
    }
  
    this.requestList = this.allRequests.filter(
      request =>
        request.bookingId.toLowerCase().includes(searchLower) ||
        request.name.toLowerCase().includes(searchLower) ||
        request.phoneNumber.includes(searchLower)
    );
  }
  

  onEnterPress(event: any): void {
    this.filterRequests();
  }

  @ViewChild('dynamicContainer', { read: ViewContainerRef }) container!: ViewContainerRef;
  @ViewChild('dynamicContainer', { read: ViewContainerRef }) recordpaymentcontainer!: ViewContainerRef;
  @ViewChild('nameInput') nameInput!: ElementRef;
  @ViewChild('mobileInput') mobileInput!: ElementRef;
  @ViewChild('regInput') regInput!: ElementRef;
  @ViewChild('issueInput') issueInput!: ElementRef;
  @ViewChild('sidebarContent') sidebarContent!: ElementRef;


  // @ViewChild(AspRecordPaymentComponent) recordPayment!: AspRecordPaymentComponent;
  loadorderdetails(bookingId,name,phoneNumber) {

    bookingId = bookingId;
    name = name;
    phoneNumber = phoneNumber;
    const factory = this.resolver.resolveComponentFactory(SideBarJobcardComponent);
    const componentRef = this.container.createComponent(factory);

    // Access the instance and call the method
    const componentBInstance = componentRef.instance as SideBarJobcardComponent;
    componentBInstance.bookingId = bookingId;
    componentBInstance.name=name;
    componentBInstance.phoneNumber=phoneNumber;
    componentBInstance.closeSidebar(true);

  }
  checkIfKeyboardIsOpen() {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.clientHeight;
    
    // If window height reduces significantly, assume keyboard is open
    this.isKeyboardOpen = windowHeight < documentHeight * 0.8;

    // Update button position dynamically
    const submitBtn = document.querySelector('.sbmtbtn') as HTMLElement;
    if (submitBtn) {
      submitBtn.style.transform = this.isKeyboardOpen ? 'translateY(-40px)' : 'translateY(0)';
    }
  }

parseCreatedAt(dateValue: string | number | Date): Date {
  if (dateValue instanceof Date) return dateValue;
  if (typeof dateValue === 'number') return new Date(dateValue);
  return new Date(dateValue.replace(' ', 'T'));
}

onRequestTimeChange(type: string): void {
  this.selectedRequestTime = type;
  this.selectedRequestTimeLabel = this.getRequestTimeLabel(type);

  const now = new Date();

  if (type === 'ANY_TIME') {
    this.requestList = [...this.allRequests];
    return;
  }

  this.requestList = this.allRequests.filter((b: any) => {
    const d = this.parseCreatedAt(b.createdAt);

    switch (type) {
      case 'TODAY':
        return d.toDateString() === now.toDateString();

      case 'YESTERDAY': {
        const y = new Date(now);
        y.setDate(now.getDate() - 1);
        return d.toDateString() === y.toDateString();
      }

      case 'LAST_7_DAYS': {
        const last7 = new Date(now);
        last7.setDate(now.getDate() - 7);
        return d >= last7 && d <= now;
      }

      case 'LAST_30_DAYS': {
        const last30 = new Date(now);
        last30.setDate(now.getDate() - 30);
        return d >= last30 && d <= now;
      }

      case 'THIS_MONTH':
        return d.getMonth() === now.getMonth() &&
               d.getFullYear() === now.getFullYear();

      case 'LAST_MONTH': {
        const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        const end = new Date(now.getFullYear(), now.getMonth(), 0);
        return d >= start && d <= end;
      }

      default:
        return true;
    }
  });
}

getRequestTimeLabel(type: string): string {
  const map: any = {
    TODAY: 'Today',
    YESTERDAY: 'Yesterday',
    LAST_7_DAYS: 'Last 7 days',
    LAST_30_DAYS: 'Last 30 days',
    THIS_MONTH: 'This month',
    LAST_MONTH: 'Last month',
    ANY_TIME: 'Any time'
  };

  return map[type] || '';
}

clearTempRequestTime(): void {
  this.tempRequestTime = null;
  this.requestList = [...this.allRequests];
}
clearRequestTimeFilter(): void {
  this.tempRequestTime = null;
  this.selectedRequestTime = null;
  this.selectedRequestTimeLabel = null;

  // ✅ Restore full list
  this.requestList = [...this.allRequests];

  this.isFilterSidebarOpen = false;
}


// clearRequestTimeFilter(): void {
//   this.tempRequestTime = null;
//   this.selectedRequestTime = null;
//   this.selectedRequestTimeLabel = null;
//   this.isFilterSidebarOpen = false;
// }


 sidecontainer() {
    this.isFilterSidebarOpen = !this.isFilterSidebarOpen; 
  }
openFilterSidebar(): void {
  this.tempRequestTime = this.selectedRequestTime;
  this.isFilterSidebarOpen = true;
}


closeFilterSidebar() {
  this.isFilterSidebarOpen = false;
}
applyRequestTimeFilter(): void {
  if (!this.tempRequestTime) return;

  // ✅ Commit temp → actual filter
  this.selectedRequestTime = this.tempRequestTime;
  this.selectedRequestTimeLabel =
    this.getRequestTimeLabel(this.tempRequestTime);

  // ✅ Apply filtering
  this.onRequestTimeChange(this.tempRequestTime);

  // ✅ Close sidebar
  this.isFilterSidebarOpen = false;
}
formatDate(dateValue: any): string {
  if (!dateValue) return 'NA';

  const date = new Date(String(dateValue).replace(' ', 'T'));

  return date.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
}


// submitBooking(form: NgForm) {
//   if (!form.valid) return;
//   this.onSubmit(form);
// }
scrollToField(fieldId: string) {
  setTimeout(() => {
    const container = this.sidebarContent?.nativeElement as HTMLElement;
    const field = document.getElementById(fieldId);

    if (!container || !field) return;

    // get positions
    const containerTop = container.getBoundingClientRect().top;
    const fieldTop = field.getBoundingClientRect().top;

    // calculate scroll position
    const scrollPosition =
      container.scrollTop + (fieldTop - containerTop) - 100;

    container.scrollTo({
      top: scrollPosition,
      behavior: 'smooth'
    });

    // focus AFTER scroll
    setTimeout(() => {
      (field as HTMLElement).focus();
    }, 300);
  });
}


submitBooking(form: NgForm) {
  Object.values(form.controls).forEach(control =>
    control.markAsTouched()
  );

  // ✅ NEW: if nothing is filled → scroll to form container
  if (
    !this.customerName &&
    !this.customerMobile &&
    !this.registratioNumber &&
    !this.issue
  ) {
    this.scrollToFormContainer();
    return;
  }

  if (form.valid) {
    this.onSubmit(form);
    return;
  }

  if (form.controls['customerName']?.invalid) {
    this.scrollToField('nameInput');
    return;
  }

  if (form.controls['customerMobile']?.invalid) {
    this.scrollToField('mobileInput');
    return;
  }

  if (form.controls['registratioNumber']?.invalid) {
    this.scrollToField('regInput');
    return;
  }

  if (form.controls['issue']?.invalid) {
    this.scrollToField('issueInput');
    return;
  }
}


onNameEntered() {
  this.checkFormValidity();
  if (this.customerName?.trim()) this.scrollToId('mobileInput');
}

onMobileEntered() {
  this.checkFormValidity();
  if (this.customerMobile?.length === 10) this.scrollToId('regInput');
}

// onRegEntered() {
//   this.checkFormValidity();
//   if (this.registratioNumber?.trim()) this.scrollToId('issueInput');
// }
onRegEntered(): void {
  this.checkFormValidity();

  if (this.registratioNumber?.trim()) {
    // ✅ Format registration number (caps + spacing)
    this.registratioNumber = this.formatRegNo(this.registratioNumber);

    // ✅ Scroll after formatting
    this.scrollToId('issueInput');
  }
}
formatRegNo(value: string): string {
  value = value.replace(/\s+/g, '').toUpperCase();

  if (value.length > 2) {
    value = value.slice(0, 2) + ' ' + value.slice(2);
  }
  if (value.length > 5) {
    value = value.slice(0, 5) + ' ' + value.slice(5);
  }
  if (value.length > 8) {
    value = value.slice(0, 8) + ' ' + value.slice(8);
  }
  return value;
}


onIssueEntered() {
  this.checkFormValidity();
}

checkFormValidity() {
  this.isBookingFormValid =
    !!this.customerName?.trim() &&
    this.customerMobile?.length === 10 &&
    !!this.registratioNumber?.trim() &&
    !!this.issue?.trim();
}
scrollToFormContainer() {
  setTimeout(() => {
    const container = this.sidebarContent?.nativeElement as HTMLElement;
    const target = container?.querySelector(
      '.booking-sidebar-form-main'
    ) as HTMLElement;

    if (!container || !target) return;

    container.scrollTo({
      top: target.offsetTop - 16,
      behavior: 'smooth'
    });
  }, 0);
}

scrollToId(targetId: string) {
  const container = document.querySelector('.sidebar-content') as HTMLElement;
  const target = document.getElementById(targetId) as HTMLElement;

  if (!container || !target) return;

  const offset =
    target.getBoundingClientRect().top -
    container.getBoundingClientRect().top;

  container.scrollTop += offset - 500;
}

}
